import {Filter} from "@/model/filter/Filter";
import {TextFilterDto} from "@/model/api/CriteriaApi";

export class TextFilter implements Filter {
  name: string

  constructor(dto: TextFilterDto) {
    this.name = dto.id
  }
}
